/**
 * Cache tags that must drop after a purchase-order create or update.
 *
 * Detail queries key the id as a URL string; mutations often pass a
 * number. Invalidate both so the line list on the detail page and the
 * purchase-order list refetch the saved qty and unit cost.
 *
 * @param {Object} [result] Mutation result.
 * @param {*} error Mutation error.
 * @param {Object} [arg] Mutation arguments.
 * @return {Array<string|Object>}
 */
export function purchaseOrderDocumentInvalidationTags(result, error, arg) {
  if (error) return [];
  const tags = ["purchaseOrderList"];
  const id = result?.id ?? arg?.id;
  if (id == null || id === "") return tags;
  tags.push(
    { type: "purchaseOrderDetail", id: String(id) },
    { type: "purchaseOrderDetail", id: Number(id) },
  );
  return tags;
}
